import { render, staticRenderFns } from "./ChrismastBanner.vue?vue&type=template&id=4c1567d1&scoped=true&"
import script from "./ChrismastBanner.vue?vue&type=script&lang=js&"
export * from "./ChrismastBanner.vue?vue&type=script&lang=js&"
import style0 from "./ChrismastBanner.vue?vue&type=style&index=0&id=4c1567d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1567d1",
  null
  
)

export default component.exports